import { Link } from "react-router-dom";

import "./footer.css";

function Footer() {
    return <div className="footer">
        <p>
            Theresienstraße 148<br/>
            D-80336 München<br/>
            
            <a href="tel:+49 89 43630078">+49 89 43630078</a><br/>
            <a href="mailto:info@info@tanztherapie-muenchen.de">info@tanztherapie-muenchen.de</a>
        </p>
        <Link to="/links" >Weiterführende Links</Link>
        <Link to="/kontakt" >Kontakt</Link>
        <Link to="/impressum" >Impressum</Link>
        <Link to="/datenschutz" >Datenschutz</Link>
        <p>© Solveig Marita Bissinger 2026</p>
    </div>
}

export default Footer;